var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V3.5L16 3",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C12.3284 12 13 11.3284 13 10.5C13 9.67157 12.3284 9 11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12Z",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#067BF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48 22V15.52H6.28V16.488H4.912V18.12H6.104V19.12H4.912V22H3.48ZM7.42875 22V15.52H8.86075V21.032H10.3488V22H7.42875ZM11.1436 22L12.3676 15.52H13.9996L15.2076 22H13.8876L13.6716 20.632H12.7196L12.4956 22H11.1436ZM12.8476 19.776H13.5356L13.1916 17.248L12.8476 19.776ZM18.0963 22.096C17.6056 22.096 17.2163 22.008 16.9283 21.832C16.6456 21.6507 16.4456 21.4 16.3283 21.08C16.211 20.7547 16.1523 20.3733 16.1523 19.936V17.6C16.1523 17.152 16.211 16.768 16.3283 16.448C16.4456 16.1227 16.6456 15.872 16.9283 15.696C17.2163 15.52 17.6056 15.432 18.0963 15.432C18.5763 15.432 18.9496 15.512 19.2163 15.672C19.4883 15.8267 19.6803 16.0453 19.7923 16.328C19.9043 16.6107 19.9603 16.936 19.9603 17.304V17.864H18.5603V17.216C18.5603 17.088 18.5523 16.9653 18.5363 16.848C18.5256 16.7307 18.4883 16.6347 18.4243 16.56C18.3603 16.48 18.251 16.44 18.0963 16.44C17.947 16.44 17.835 16.48 17.7603 16.56C17.691 16.64 17.6456 16.7413 17.6243 16.864C17.6083 16.9813 17.6003 17.1067 17.6003 17.24V20.288C17.6003 20.432 17.611 20.5653 17.6323 20.688C17.659 20.8053 17.707 20.9013 17.7763 20.976C17.851 21.0453 17.9576 21.08 18.0963 21.08C18.2456 21.08 18.3523 21.0427 18.4163 20.968C18.4803 20.888 18.5203 20.7867 18.5363 20.664C18.5523 20.5413 18.5603 20.416 18.5603 20.288V19.608H19.9603V20.168C19.9603 20.536 19.9043 20.8667 19.7923 21.16C19.6856 21.448 19.4963 21.6773 19.2243 21.848C18.9576 22.0133 18.5816 22.096 18.0963 22.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlac);
export default __webpack_public_path__ + "static/media/flac.bd9e5545b91adef0caa0b67db93c901c.svg";
export { ForwardRef as ReactComponent };